import React, { useState, useEffect } from 'react';
import GameContentProvider from '../providers/GameContentProvider';
import './WaitingScreen.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { loadGuestToken } from '../auth/authSlice';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next'; // Import useTranslation
import AncientSofiaHook from '../starters/AncientSofiaHook';


const WaitingScreen = (props) => {
    const { t } = useTranslation(); // Initialize useTranslation

    const [teamGameId, setTeamGameId] = useState(null);
    const [code, setCode] = useState(null);
    const [startTime, setStartTime] = useState(null);
    const [startTimeLocal, setStartTimeLocal] = useState(null);
    const [arrayTeams, setTeams] = useState([]);
    const [isModalOpen, setModalOpen] = useState(false);
    const [newTeamName, setNewTeamName] = useState('');
    const [showAddTeamButton, setShowAddTeamButton] = useState(true);
    const [showJoinTeamOverlay, setShowJoinTeamOverlay] = useState(false);
    const [selectedTeam, setSelectedTeam] = useState(null);
    const [currentTeam, setCurrentTeam] = useState(null);
    const [token, setToken] = useState(null);
    const [remainingTime, setRemainingTime] = useState(null);
    const [isTeamMember, setIsTeamMember] = useState(null);
    const [gameId, setGameId] = useState(null);
    const [gameStarted, setGameStarted] = useState(false);
    const [showHook, setShowHook] = useState(false);


    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        const fetchData = async () => {
            const { state } = location;
            console.log('Received data:', state);
            setCode(state.code);
            setStartTime(state.start_date);
            setGameId(state.game_id);
            console.log('game:', state.game_id);
            console.log('code:', state.code);
            console.log('startTime:', state.start_date);
            console.log('team_game_id:', state.team_game_id);

            const currentDate = new Date();
            const startDate = new Date(state.start_date);
            // const currentUtcDate = new Date(currentDate.getTime() + (currentDate.getTimezoneOffset() * 60000)); 
            const currentUtcDate = new Date(currentDate.getTime());
            setStartTimeLocal(new Date(startDate.getTime()));
            const diff = startDate - currentUtcDate;
            setRemainingTime(diff);

            if (currentUtcDate > startDate) {
                try {
                    const gameContentProvider = new GameContentProvider();
                    const couponData = await gameContentProvider.checkCode(state.code);
                    console.log(couponData);
                } catch (error) {
                    console.error('Error checking coupon:', error);
                }
            }

            console.log("Fetching data for code:", state.code);
            if (state.code) {
                try {
                    const gameContentProvider = new GameContentProvider();
                    const teams = await gameContentProvider.getTeams(state.code);
                    let teamGameIdLocal;
                    setTeams(teams);
                    if (teams && teams.length > 0) {
                        teamGameIdLocal = teams[0].team_game_id;
                        setTeamGameId(teamGameIdLocal);
                    }

                    let token;
                    token = localStorage.getItem('token');
                    if (!token) {
                        token = localStorage.getItem('guest_token');
                    }

                    console.log("Current token: " + token);

                    if (token) {
                        setToken(token);
                        const is_teamMember = await gameContentProvider.checkTeamMember(token, teamGameIdLocal);
                        setIsTeamMember(is_teamMember);

                        console.log("Check team member part of team");
                        console.log(is_teamMember);
                        if (is_teamMember && is_teamMember.success) {
                            setCurrentTeam(is_teamMember.team);
                            setShowAddTeamButton(false);
                        }
                    }
                } catch (error) {
                    console.error('Error fetching teams:', error);
                }
            } else {
                console.log("Code is null");
            }
        };

        fetchData();
    }, [location]);

    useEffect(() => {
        const timer = setInterval(() => {
            setRemainingTime(prevTime => {
                const newTime = prevTime - 1000;
                return newTime <= 0 ? 0 : newTime; // Ensure remaining time doesn't go negative
            });
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    useEffect(() => {
        if (remainingTime === 0) {
            // Call your function here
            // handleTimerEnd();
            setGameStarted(true);
        } else {
            console.log(remainingTime);
        }
    }, [remainingTime]);

    const actualStartTeamGame = () => {
        const data = {
            game: gameId,
            step: 1,
            team_game_id: teamGameId,
        };

        const otherComponentURL = '/game-team-steps';

        const gameStepsWindow = window.open(otherComponentURL, '_blank');
        if (!gameStepsWindow) {
            console.log("gameStepsWindow is null");
        }

        gameStepsWindow.addEventListener('load', () => {
            gameStepsWindow.postMessage(data, window.origin);
        });

        navigate("/");
    };

    const handleTimerEnd = () => {
        // Your function logic here
        console.log("Timer is over!");

        if (isTeamMember && isTeamMember.success) {
            //Part of team. Start the game

            console.log("Is team member");
            if (Number(gameId) === 10) {
                setShowHook(true);
            } else {
                actualStartTeamGame();
            }
        } else {
            console.log("Not team member.");

            navigate("/");
        }

    };

    const formatTime = (milliseconds) => {
        const totalSeconds = Math.floor(milliseconds / 1000);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };

    const addTeam = () => {
        setModalOpen(true);
    };

    const handleItemClick = (team) => {
        if (!currentTeam) {
            setSelectedTeam(team);
            setShowJoinTeamOverlay(true);
        } else {
            console.log("Already part of team: " + currentTeam);
        }
    };

    const handleJoinTeam = async () => {
        setShowJoinTeamOverlay(false);
        console.log("Join team");

        const gameContentProvider = new GameContentProvider();
        const resut = await gameContentProvider.joinTeam(selectedTeam.id, token);

        if (resut) {
            setCurrentTeam(selectedTeam.name);
        }
    };

    const handleAddTeam = async () => {
        if (newTeamName) {
            console.log("Adding team:", newTeamName);

            try {
                const gameContentProvider = new GameContentProvider();
                let token;
                const user_token = localStorage.getItem('token');
                if (user_token) {
                    token = user_token;
                } else {
                    const guest_token = localStorage.getItem('guest_token');
                    if (guest_token) {
                        token = guest_token;
                    } else {
                        const newToken = await gameContentProvider.registerGuest();
                        console.log("New token: " + newToken.token);
                        localStorage.setItem('guest_token', newToken.token);
                        dispatch(loadGuestToken());
                        token = newToken.token;
                    }
                }
                setToken(token);

                const team = await gameContentProvider.addTeam(teamGameId, newTeamName, token);
                if (team) {
                    setTeams((prevItems) => [...prevItems, team]);
                    setNewTeamName('');
                    setCurrentTeam(team.name);
                    setShowAddTeamButton(false);
                }
            } catch (error) {
                console.error('Error fetching teams:', error);
            }

            setModalOpen(false);
        }
    };

    const closeModal = () => {
        setModalOpen(false);
    };

    if (showHook) {
        return <AncientSofiaHook onGameStart={actualStartTeamGame} />;
    }

    return (
        <div className='waitingscreen'>
            <div className='background-image-waiting-screen' />
            <div className='center-container-waiting-screen'>
                <div>
                    {startTimeLocal && (<p>{t('game_starts_at')}: {startTimeLocal.toLocaleString()}</p>)}

                    {remainingTime !== null && remainingTime > 0 && (
                        <p>{t('remaining_time')}: <span style={{ fontSize: '24px' }}>{formatTime(remainingTime)}</span></p>
                    )}
                </div>
                <div>
                    <p>{t('game_code')}: {code}</p>
                </div>
                <div className="team-list-container">
                    <h3>{t('waiting_teams')}:</h3>
                    <ul className="team-list">
                        {arrayTeams.map((team) => (
                            <li
                                key={team.id}
                                onClick={() => handleItemClick(team)}
                                className={selectedTeam && selectedTeam.id === team.id ? 'selected' : ''}
                            >
                                {team.name}
                            </li>
                        ))}
                    </ul>
                </div>
                <div style={{ marginTop: '10px' }}>
                    {showAddTeamButton && <button onClick={addTeam}>{t('add_team')}</button>}
                </div>
            </div>

            {isModalOpen && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <h2>{t('add_team')}</h2>
                        <input
                            type="text"
                            value={newTeamName}
                            onChange={(e) => setNewTeamName(e.target.value)}
                            placeholder="Enter team name"
                        />
                        <button onClick={handleAddTeam} style={{ marginRight: '10px' }}>{t('add')}</button>
                        <button onClick={closeModal}>{t('close')}</button>
                    </div>
                </div>
            )}

            {showJoinTeamOverlay && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <h2>{t('do_you_want_to_join_team')}:</h2>
                        <h2> {selectedTeam ? selectedTeam.name : ''}</h2>
                        <button onClick={() => handleJoinTeam()} style={{ marginRight: '10px' }}>{t('join')}</button>
                        <button onClick={() => setShowJoinTeamOverlay(false)}>{t('close')}</button>
                    </div>
                </div>
            )}


            {gameStarted && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <h2>{t('the_game_has_started')}!</h2>
                        <button onClick={handleTimerEnd}>{t('join')}</button>
                    </div>
                </div>
            )}

        </div>
    );
};

export default WaitingScreen;
